import { Card, CardContent, CardHeader } from "@mui/material";
import React from "react";
import _ from "lodash";
import Checkbox from "../CommonComponents/Checkbox";

const ZoomCards = ({
  studentsData,
  setBatchStudents,
  batch,
  selectedStudents,
  setSelectedStudents,
  batchStudentsData,
}) => {
  const onChange = (checked, student) => {
    setBatchStudents((prevBatchStudents) => ({
      ...prevBatchStudents,
      [batch]: {
        ...prevBatchStudents[batch],
        [student]: {
          ...prevBatchStudents[batch][student],
          checked: checked,
        },
      },
    }));
    batchStudentsData.current = {
      ...batchStudentsData.current,
      [batch]: {
        ...batchStudentsData.current[batch],
        [student]: {
          ...batchStudentsData.current[batch][student],
          checked: checked,
        },
      },
    };
    let newDetails = JSON.parse(JSON.stringify(selectedStudents));
    if (checked) newDetails.push(studentsData[student] || {});
    else
      newDetails = _.filter(
        newDetails,
        (data) => data.learnerid !== studentsData[student].learnerid
      );
    setSelectedStudents(newDetails);
  };

  console.log("studentsData", studentsData);
  return (
    <Card>
      <CardHeader id="zoomCardHeader" title={batch} />
      <CardContent className="zoomCardContent">
        {_.map(Object.keys(studentsData), (student, index) => (
          <div
            className="zoomCardContentDetail"
            title={studentsData[student].name}
            key={index}
          >
            <Checkbox
              key={index}
              text={studentsData[student].name.substring(
                0,
                studentsData[student].name.indexOf("(")
              )}
              size="sm"
              checked={studentsData[student].checked || false}
              onChange={(checked) => onChange(checked, student)}
            />
            <span className="zoomCardContentTestName">
              {studentsData[student].name.substring(
                studentsData[student].name.indexOf("(")
              )}
            </span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default ZoomCards;
